class PlugHeader extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.elements = {
            desktopL1ListItems: Array.from(this.getElementsByClassName("plug-header-menu__l1")),
            desktopL1Links: Array.from(this.getElementsByClassName("plug-header-menu__l1-link")),
            headerBar: this.querySelector(".plug-header__bar"),
            headerSection: this.closest(".plug-header-section"),
            megaMenus: Array.from(this.getElementsByClassName("plug-header__mega-menu")),
            menuButton: this.querySelector(".plug-header__icon-item--menu .plug-header__icon-button"),

            // mobileMenu: this.querySelector("plug-mobile-menu"),

            searchButtons: Array.from(this.querySelectorAll(".plug-header__icon-item--search .plug-header__icon-button")),
            searchInput: this.querySelector(".plug-header__search-input"),
            searchOverlayCloseButton: this.querySelector(".plug-header__search-overlay-close"),
            searchOverlay: this.querySelector(".plug-header__search-overlay"),
            searchResetButton: this.querySelector(".plug-header__search-reset"),
        };

        // Only transparent when header is in initial position (not when sticky).
        this.hasTransparentBg = (this.dataset.hasTransparentBg === "true");

        this.openMegaMenuId = undefined;

        this.initListeners();
    }

    initListeners() {

        // Search listeners.

        this.elements.searchButtons.forEach(button => {
            button.addEventListener("click", (e) => {
                if (this.isBoostMobile()) {
                    this.elements.searchInput.click();
                } else {
                    this.elements.searchOverlay.classList.remove("is-hidden");
                    this.elements.searchInput.focus();
                }
            });
        });

        this.elements.searchInput.addEventListener("input", (e) => {
            if (e.target.value.length > 0) {
                this.elements.searchResetButton.classList.remove("is-hidden");
            } else {
                this.elements.searchResetButton.classList.add("is-hidden");
            }
        });

        this.elements.searchResetButton.addEventListener("click", (e) => {
            this.elements.searchInput.value = "";
        });

        this.elements.searchOverlayCloseButton.addEventListener("click", (e) => {
            this.elements.searchOverlay.classList.add("is-hidden");
        });

        // Mega menu listeners.

        this.elements.desktopL1Links.forEach((link, l1LinkIndex) => {
            const listItem = link.closest(".plug-header-menu__l1");
            const megaMenuId = listItem.dataset.megaMenuId;
            const megaMenu = document.getElementById(megaMenuId);
            let leaveTimeout;

            const handleMouseLeave = () => {
                leaveTimeout = setTimeout(() => {
                    listItem.classList.remove("is-active");
                    this.closeMegaMenu(megaMenuId);
                }, 100);
            };

            link.addEventListener("mouseenter", () => {
                clearTimeout(leaveTimeout);
                this.openMegaMenuId = megaMenuId;
                this.elements.headerSection.classList.add("plug-force-bg");
                listItem.classList.add("is-active");
                if (megaMenu && megaMenu.classList.contains("is-open")) {
                    return;
                }
                if (megaMenu) {
                    this.openMegaMenu(megaMenu);
                    this.closeAllMegaMenus(megaMenuId);
                }
            });

            if (megaMenu) {
                megaMenu.addEventListener("mouseenter", () => {
                    clearTimeout(leaveTimeout);
                });

                megaMenu.addEventListener("mouseleave", () => {
                    handleMouseLeave();
                });
            }

            link.addEventListener("mouseleave", handleMouseLeave);

            link.addEventListener("keydown", (e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    this.openMegaMenuId = megaMenuId;
                    this.elements.headerSection.classList.add("plug-force-bg");
                    listItem.classList.add("is-active");
                    if (megaMenu && !megaMenu.classList.contains("is-open")) {
                        this.openMegaMenu(megaMenu, true);
                        link.setAttribute("aria-expanded", "true");
                        this.closeAllMegaMenus(megaMenuId);
                    }
                } else if (e.key === "ArrowLeft" || e.key === "ArrowRight") {
                    if (e.key === "ArrowRight") {
                        if (l1LinkIndex < this.elements.desktopL1Links.length - 1) {
                            e.preventDefault();
                            this.elements.desktopL1Links[l1LinkIndex + 1].focus();
                        } else if (l1LinkIndex === this.elements.desktopL1Links.length - 1) {
                            e.preventDefault();
                            this.elements.desktopL1Links[0].focus(); // Loop to first link
                        }
                    } else if (e.key === "ArrowLeft") {
                        if (l1LinkIndex > 0) {
                            e.preventDefault();
                            this.elements.desktopL1Links[l1LinkIndex - 1].focus();
                        } else if (l1LinkIndex === 0) {
                            e.preventDefault();
                            this.elements.desktopL1Links[this.elements.desktopL1Links.length - 1].focus(); // Loop to last link
                        }
                    }
                }
            });

            if (megaMenu) {
                megaMenu.addEventListener("keydown", (e) => {
                    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
                        const currentlyFocused = document.activeElement;
                        const links = megaMenu.querySelectorAll("a");
                        const currentIndex = Array.from(links).indexOf(currentlyFocused);
                        if (currentIndex >= 0) {
                            if (e.key === "ArrowDown") {
                                if (currentIndex < links.length - 1) {
                                    e.preventDefault();
                                    links[currentIndex + 1].focus();
                                } else if (currentIndex === links.length - 1) {
                                    e.preventDefault();
                                    links[0].focus(); // Loop to first link
                                }
                            } else if (e.key === "ArrowUp") {
                                if (currentIndex > 0) {
                                    e.preventDefault();
                                    links[currentIndex - 1].focus();
                                } else if (currentIndex === 0) {
                                    e.preventDefault();
                                    links[links.length - 1].focus(); // Loop to last link
                                }
                            }
                        }
                    } else if (e.key === "Escape") {
                        e.preventDefault();
                        this.closeMegaMenu(megaMenuId);
                        listItem.classList.remove("is-active");
                        link.focus(); // Return focus to the link that opened the menu
                    }
                });
            }
        });
    }

    openMegaMenu(megaMenu, focusFirstLink = false) {
        megaMenu.classList.remove("is-hidden");
        requestAnimationFrame(() => {
            setTimeout(() => {
                megaMenu.classList.add("is-open");
                if (focusFirstLink) {
                    const firstLink = this.findFirstMegaMenuLink(megaMenu);
                    if (firstLink) {
                        firstLink.focus();
                    }
                }
            }, 0);
        });
    }

    closeAllMegaMenus(excludeId) {
        this.elements.desktopL1ListItems.forEach(listItem => {
            if (listItem.dataset.megaMenuId !== excludeId) {
                this.closeMegaMenu(listItem.dataset.megaMenuId);
            }
        });
    }

    closeMegaMenu(id) {
        if (id === this.openMegaMenuId) {
            this.openMegaMenuId = undefined;
            setTimeout(() => {
                if (!this.openMegaMenuId) {
                    this.elements.headerSection.classList.remove("plug-force-bg");
                }
            }, 200);
        }
        const megaMenu = document.getElementById(id);
        if (!megaMenu) return;
        const link = this.elements.desktopL1Links.find(link => link.dataset.megaMenuId === id);
        if (link) {
            link.setAttribute("aria-expanded", "false");
        }
        megaMenu.classList.remove("is-open");
        megaMenu.classList.add("is-hidden");
    }

    isBoostMobile() {
        return window.innerWidth < 992;
    }

    findFirstMegaMenuLink(megaMenu) {
        return megaMenu.querySelector("a");
    }
}

if (!customElements.get("plug-header")) {
    customElements.define("plug-header", PlugHeader);
}
